const modules = {};
const context = require.context('./', false, /\.js$/);

context.keys().forEach(key => {
	if (key === './index.js') return;
	const name = key.replace(/^\.\//, '').replace(/\.js$/, '');
	modules[name] = context(key).default;
});

export default modules;
